import type { NavigateFunction } from 'react-router-dom';
import type { AIAction } from '../types/ai-assistant-types';

/**
 * Execute an AI-triggered action in the frontend.
 * Maps action types to navigation and app behavior.
 */
export function handleAIAction(action: AIAction, navigate: NavigateFunction): void {
  switch (action.type) {
    case 'navigate':
      if (action.payload.path) {
        navigate(action.payload.path);
      }
      break;

    case 'book_appointment':
      navigate('/schedule-appointment');
      break;

    case 'show_test_result':
      navigate('/test-results', { state: action.payload });
      break;

    case 'show_medication':
      navigate('/medications', { state: action.payload });
      break;

    case 'show_appointment':
      navigate('/appointments', { state: action.payload });
      break;

    case 'link':
      if (action.payload.external) {
        window.open(action.payload.url, '_blank', 'noopener,noreferrer');
      } else if (action.payload.url) {
        navigate(action.payload.url);
      }
      break;

    case 'copy_to_clipboard':
      if (action.payload.text) {
        navigator.clipboard.writeText(action.payload.text);
      }
      break;

    case 'open_modal':
      window.dispatchEvent(
        new CustomEvent('ai-open-modal', { detail: action.payload }),
      );
      break;

    default:
      console.warn('Unknown AI action type:', action.type);
  }
}
